'use strict'
import { plainToClass } from 'class-transformer'
import Response from '@/utils/response'
import Matchingship from '@/models/matchingship'
import pageLoading from '@/mixins/page-loading'
import pageTitle from '@/mixins/page-title'
import AnswerForm from '@/components/form/AnswerForm'

export default {
  components: {
    AnswerForm
  },
  mixins: [
    pageLoading,
    pageTitle
  ],
  title () {
    return this.$t("pages.user.answers.new.title")
  },
  props: {
    repository: Object,
    id: Number
  },
  data () {
    return {
      matchingship: new Matchingship
    }
  },
  computed: {
    backRoute () {
      return { name: 'matching-index' }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.getById(this.id))
        if (response.success) {
          this.matchingship = plainToClass(Matchingship, response.result)
          this.$nextTick(() => (this.$refs.form.start()))
        } else {
          this.$store.commit('setSnackbar', response.snackbarParams)
          this.$router.go(-1)
        }
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    async submit (postParams) {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.answer(this.id, postParams))
        if (response.eqStatus('reject')) {
          this.$refs.form.reject(response.result.message)
        } else {
          this.$store.commit('setSnackbar', response.snackbarParams)
          this.$router.replace({
            name: 'answer-edit',
            params: { id: response.result.id }
          })
        }
      } catch(error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    }
  }
}
